<template>
  <div class="g-top">
    <div class="g-top-content">
      <span class="top-login" @click="show=true;" v-if="!user">
        Please log in
      </span>
      <span class="top-reg" @click="$router.push('/loginEn/registerEn');" v-if="!user">
        Register
      </span>
      <Dropdown trigger="hover" v-if="user">
        <span style="line-height: 30px;cursor:pointer;">{{user.name || "匿名用户"}}</span>
        <DropdownMenu slot="list" style="width:165px; text-align: center;">
          <DropdownItem @click.native="modelShow=true">Personal information</DropdownItem>
          <DropdownItem @click.native="collectOpen=true">Exhibitors</DropdownItem>
          <DropdownItem @click.native="procollectOpen=true">Products</DropdownItem>
          <DropdownItem @click.native="chancecollectOpen=true">Supply and Demand</DropdownItem>
          <DropdownItem @click.native="linkToEx">Exhibitor login</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <span v-if="user" style="line-height: 30px;cursor:pointer;" @click="isExit=true;"> ， 退出</span>
      <span class="line">|</span>
      <span class="top-cn" @click="goCn">中</span>
      <span class="line">|</span>
      <span class="top-en">En</span>
    </div>

    <gLogin :show="show"  :isPwd='false' @close="show=false;" />
    <editInfo :show="modelShow" :modelTitle="modelTitle" @close="modelShow = false" @finsh="finsh"></editInfo>
    <myCollect :show="collectOpen" @close="collectOpen=false"></myCollect>
    <proCollect :show="procollectOpen" @close="procollectOpen=false"></proCollect>
    <chanceCollect :show="chancecollectOpen" @close="chancecollectOpen=false"></chanceCollect>
    <iModal cancel-text title="" width="416" v-model="isExit" :closable="false" :footer-hide="true">
      <div class="exit-modal">
        <div class="exit-modal-top">
          <Icon type="ios-alert" color="#f90" size="28" />
          <p>Confirm</p>
        </div>
        <div class="exit-modal-bottom">
          <p>是否退出 ？</p>
        </div>
        <div class="exit-modal-btn">
          <Button type="text" @click="isExit=false;">Cancel</Button>
          <Button type="primary" @click="confirm()" style="margin-left:10px;">Confirm</Button>
        </div>
      </div>
    </iModal>
  </div>
</template>

<script>
import config from "@assets/config.json";
import gLogin from "@components/En/gLogin/gLogin.vue";
import editInfo from "../modal/edit-info";
import myCollect from "../modal/my-collect";
import proCollect from "../modal/pro-collect";
import chanceCollect from "../modal/chance-collect";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "g-top",
  data() {
    return {
      show: false,
      modelShow: false,
      collectOpen:false,
      procollectOpen:false,
      chancecollectOpen:false,
      modelTitle: "我的信息",
      isExit: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    })
  },
  created() {
    // console.log("用户信息：",this.user);
  },
  methods: {
    ...mapActions({
      exit: "loginModule/exit"
    }),
    finsh() {},
    linkToEx() {
      window.open(`${config.BackendUrl}/exhibitionEn/login/alogin`);
    },
    goCn() {
      // let url = location.origin + "/home";
      let url = 'https://www.cmef.com.cn/exhibitorlist?type=2&cid=96'
      window.open(url, "_blank");
    },
    confirm() {
      this.isExit=false;

       sessionStorage.setItem('companyListLogin','')
             sessionStorage.setItem('byCompIdListLogin','')
             sessionStorage.setItem('proListLogin','')
             sessionStorage.setItem('accountPassword','')
      setTimeout(() => {
        this.exit();
      },100)
    }
  },
  components: {
    gLogin,
    editInfo,
    myCollect,
    proCollect,
    chanceCollect
  }
};
</script>

<style lang="scss" scoped>
.g-top {
  width: 100%;
  height: 30px;
  background-color: #f5f5f5;
  &-content {
    width: 1200px;
    margin: 0 auto;
    text-align: right;
    font-size: 12px;
  }
  .top-login {
    cursor: pointer;
    line-height: 30px;
  }
  .top-reg {
    color: #e60012;
    margin-left: 5px;
    cursor: pointer;
  }
  .line {
    color: #e6e6e6;
    font-size: 14px;
    margin: 0 10px;
  }
  .top-en {
    display: inline-block;
    width: 30px;
    height: 17px;
    background-color: #024c8b;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }
  .top-cn {
    cursor: pointer;
  }
}
.exit-modal {
  padding: 6px 16px 8px;
  &-top {
    display: flex;
    align-items: center;
    p {
      padding-left: 12px;
      color: #17233d;
      font-size: 16px;
      line-height: 42px;
    }
  }
  &-bottom {
    margin-left: 40px;
  }
  &-btn {
    text-align: right;
    margin-top: 20px;
  }
}
</style>